<div class="page-wrapper theme-background">

  <div class="page-body">

    <div class="container-xl">
      <div class="row">
        <div class="col">
          <h1 class="text-welcome display-7 display-md-6 px-2 mb-3">
            {{ 'welcome' | translate }} {{ givenName }}
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 order-last order-md-first mt-3 mt-md-0">
          <div class="row">
            <div class="col-12">
              <app-news></app-news>
            </div>
          </div>
        </div>
        <div class="col-md-6 order-first order-md-last">
          <div class="row">
            <div class="col-12">
              <app-announcement></app-announcement>
            </div>
            <div class="col-12 mt-3">
              <app-apps-card></app-apps-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-news-slideout></app-news-slideout>